import { FC, PropsWithChildren, useState } from 'react'

import { Modal, Popover } from 'antd'
import styled, { css } from 'styled-components'
import { PopoverProps } from 'antd/lib'
import { useMediaQuery } from 'react-responsive'
import { TooltipPlacement } from 'antd/es/tooltip'

import { MAX_TABLET_WIDTH } from 'src/Styled/variables'

import { QuestionButton } from '../QuestionButton'
import { GreyTextButton } from '../Buttons/GreyTextButton'

const StyledGreyTextButton = styled(GreyTextButton)`
  padding-left: 40px;
  padding-right: 40px;
`
const contentStyles = css`
  display: flex;
  width: 280px;
  padding: 24px;
  padding-bottom: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  background-color: ${({ theme }) => theme.color.white};
  box-shadow: ${({ theme }) => theme.shadow.header};
`

const StyledModal = styled(Modal)`
  &.ant-modal {
    padding-bottom: 24px;
  }

  & .ant-modal-content {
    ${contentStyles}
  }

  & .ant-modal-body {
    padding: 0;
  }
`
const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding-bottom: 24px;
`
const DefaultText = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`

const StyledPopover = styled((props: PopoverProps) => (
  <Popover {...props} classNames={{ root: props.className }} />
))`
  .ant-popover-inner {
    ${contentStyles}
  }
`

export type PrimaryHintProps = PropsWithChildren & {
  placement?: TooltipPlacement
  component?: React.FC
}

export const PrimaryHint: FC<PrimaryHintProps> = ({
  children,
  placement = 'topLeft',
  component: Component = QuestionButton,
}) => {
  const isDesktop = useMediaQuery({ minWidth: MAX_TABLET_WIDTH })
  const [isVisibleHint, setIsVisibleHint] = useState(false)

  const handleVisibleChange = (visible: boolean): void => {
    setIsVisibleHint(visible)
  }
  const content = (
    <ContentContainer>
      <DefaultText>{children}</DefaultText>
      <StyledGreyTextButton onClick={() => handleVisibleChange(false)}>
        Got it
      </StyledGreyTextButton>
    </ContentContainer>
  )
  if (isDesktop) {
    return (
      <StyledPopover
        open={isVisibleHint}
        placement={placement}
        trigger={['click']}
        content={content}
        arrow={false}
        onOpenChange={handleVisibleChange}
      >
        <Component />
      </StyledPopover>
    )
  }
  return (
    <>
      <StyledModal
        open={isVisibleHint}
        footer={null}
        closeIcon={null}
        centered
        width={280}
        onCancel={() => handleVisibleChange(false)}
      >
        {content}
      </StyledModal>
      <Component onClick={() => handleVisibleChange(true)} />
    </>
  )
}
